import { defineStore } from 'pinia'
import { messageService } from '@/services/messageService'
import errorService from '@/services/errorService';

export const useMessageStore = defineStore('message', {
  state: () => ({
    messages: {
      data: {},
      meta: {}
    },
    message: {},
    filter: {},
    reply: {},
  }),

  actions: {
    async getMessages() {
      try {
        const response = await messageService.fetchMessages(this.filter);
        this.messages = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getMessage(id) {
      try {
        const response = await messageService.fetchMessage(id);
        this.message = response.data.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async replyMessage(id, params) {

      try {
        const response = await messageService.replyMessage(id, params);
        this.message.replies.push(response.data.data);

        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async toggleFavorite(id) {
      try {
        const response = await messageService.toggleFavorite(id);
        this.message.favorite = response.data.data.favorite;
        return { success: true };
      } catch (error) {
        return errorService.handle(error);
      }
    },

  }
});